var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { classNames } from "../../util/common-utilities";
import dotsGif from "../../media/dots_loading.gif";
export default function Loading() {
    return (_jsxs("div", __assign({ className: classNames("text-center") }, { children: [_jsx("img", { className: classNames("justify-center mx-auto"), src: dotsGif, alt: "Loading" }, void 0), _jsx("p", __assign({ className: classNames("text-2xl color-QUIZ_BUTTON_COLOR") }, { children: "Loading" }), void 0)] }), void 0));
}
